export default {

  /** 成功 */
  SUCC: 1,

  /** 失败 */
  FAIL:-1,

  /** 未登录 */
  UNAUTHEN: 4007,

  /** 未授权，拒绝访问 */
  UNAUTHZ: 4403,

  /** session超时退出了登录 */
  SESSION_TIMOUT: 4004,

  /** 服务端异常 */
  SERVER_ERR: 5500

}




// WEBPACK FOOTER //
// ./src/utils/code.js